import HeetsCollectionSlider from "./HeetsCollectionSlider";
export default HeetsCollectionSlider;